import React from 'react';
import Hero from '../components/home/Hero';
import SolutionCategoriesSection from '../components/home/SolutionCategoriesSection';
import CapacityStrip from '../components/CapacityStrip';
import StatsSection from '../components/home/StatsSection';
import ManufacturingSection from '../components/home/ManufacturingSection';
import ProcessTimelineSection from '../components/home/ProcessTimelineSection';
import ProjectsSection from '../components/home/ProjectsSection';
import WhyAldenSection from '../components/home/WhyAldenSection';
import KnowledgeHubSection from '../components/home/KnowledgeHubSection';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';
import GoogleReviewsStrip from '../components/GoogleReviewsStrip';
import SEOHead from '../components/seo/SEOHead';
import { JsonLd, organizationSchema } from '../components/seo/schemas';

const HomePage = () => {
  return (
    <div className="min-h-screen pb-20 lg:pb-0">
      <JsonLd data={organizationSchema()} />
      <SEOHead
        title="Mineral Water Plant Manufacturer in India | Water Treatment, Bottling & Packaging Machinery | Alden Technologies"
        description="Alden Technologies — turnkey water, beverage & packaging engineering: mineral water plants (20–200 BPM), RO/WTP/STP/ETP/ZLD systems, bottle filling machines, PET blowing & packaging machinery. In-house fabrication, PAN India service. Call +91 93512 92512."
        path="/"
      />
      <Hero />
      <GoogleReviewsStrip />
      <SolutionCategoriesSection />
      <CapacityStrip />
      <StatsSection />
      <ManufacturingSection />
      <ProcessTimelineSection />
      <ProjectsSection />
      <WhyAldenSection />
      <KnowledgeHubSection />
      <FAQSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
